import React from 'react'
import PropTypes from 'prop-types'
import DuplicateIcon from './../icons/DuplicateIcon'
import './../../ui.style.scss'

const DuplicateButton = ({ isDisabled, onClick, ...props }) => (
  <div className={`black-button duplicate ${isDisabled ? 'disabled' : ''}`} onClick={onClick} >
    <DuplicateIcon />
  </div>
)

DuplicateButton.propTypes = {
  /** disabled status of Button. */
  isDisabled: PropTypes.bool,
  /** Button click action. */
  onClick: PropTypes.func.isRequired
}

DuplicateButton.defaultProps = {
  isDisabled: false
}

export default DuplicateButton
